import axios from 'axios';
import config from "../../config/config";
import { searchTopicUrlQuery } from "../../openSearchQueries";

export function responseHasErrored(bool,response) {
  return {
    type: 'RESPONSE_HAS_ERRORED',
    hasErrored: bool,
    errorResponse : response
    }
}
export function fetchDataSuccess(serviceResponse,type) {
  var $type = "";
  switch(type){
      case "getTopicData" :
          $type = "LOAD_TOPICS_SUCCESS";
          break;
      case "getTopicRenderingData" :
          $type = "RENDER_TOPIC_SUCCESS";
          break;
      default:
          $type = "FETCH_DATA_SUCCESS";
          break;
  }
return {
  type: $type,
          serviceResponse
        }
}
export function fetchDataFromServices(url,objectCode) {
  //var requestId = (new Date().getTime()).toString(16);
  const requestOptions = {
        //   headers: {
        //     'Cache-Control'	 :  'no-cache, no-store, private, must-revalidate, max-age=0, no-transform',
        //     //'Pragma'			 :  'no-cache',
        //     'Expires'		 	 : 	0,
        //     'X-XSS-Protection' :  1,
        //     'x-request-id'	 : requestId,
        //     'Access-Control-Allow-Origin' : '*',
        //     'Access-Control-Allow-Credentials':true,
        //     'content-type'	 : 'application/json',
        //     'accept'	         : 'application/json'
        //   },
          method: 'GET',// *GET, POST, PUT, DELETE, etc.
        //   credentials: 'include',
        //   mode:'no-cors'
      };

  return (dispatch) => {

  fetch(url,requestOptions)
  .then((response) => {
      if (response.status !== 200) {

          if(response.ok){
              var res = response.json();
               res.then((errorResponse) =>{
                    dispatch(responseHasErrored(true,errorResponse));
                    return;
                 });
          }else{
              dispatch(responseHasErrored(true,[]));
              return;
          }


      }
      return response;
    })
    .then((response) => {

        return response.json();
    })

    .then((serviceResponse) =>{
            dispatch(responseHasErrored(false,[]));
            dispatch(fetchDataSuccess(serviceResponse,objectCode));
            return ;
        })
    .catch((response) =>{
      let error = Object.getOwnPropertyDescriptor(response, 'message').value;
      if(error === 'Failed to fetch'){
        var errorResponse = {message: "Session has timed out. Please refresh the page to continue.", status: 302};
        dispatch(responseHasErrored(true,errorResponse));
        return;
      }
       //return alert("There is issue with Server");
     });

};
}


export function fetchTopicDataFromServices(url, objectCode, searchKey, genus, from) {

  return (dispatch) => {
    axios.post(url, searchTopicUrlQuery(searchKey,genus,from), {        
            })
    .then((response) => {
      if (response.status !== 200) {
        if (response.ok) {
          var res = response.json();
          res.then((errorResponse) => {
            dispatch(responseHasErrored(true, errorResponse));
            return;
          });
        } else {
          dispatch(responseHasErrored(true, []));
          return;
        }
      }
      return response;
    })
    .then((response) => {
      dispatch(responseHasErrored(false, []));
      dispatch(fetchDataSuccess(response?.data, objectCode));
      return;
    })
    .catch((response) => {
      let error = Object.getOwnPropertyDescriptor(response, "message").value;
      if (error === "Failed to fetch") {
        var errorResponse = {
          message:
            "Session has timed out. Please refresh the page to continue.",
          status: 302,
        };
        dispatch(responseHasErrored(true, errorResponse));
        return;
      }
      //return alert("There is issue with Server");
    });
  };
}